// FROM - https://getbootstrap.com/docs/4.3/layout/overview/#responsive-breakpoints

export const lgMinBreakpoint: number = 991;
export const xlMinBreakpoint: number = 1199;